import styled from 'styled-components';

interface AvatarSectionContainerProps {
  disable?: boolean;
}

export const AvatarSectionContainer = styled.section.attrs(() => ({
  className: 'SettingsMemberProfileAvatarSectionContainer',
}))<AvatarSectionContainerProps>`
  display: flex;
  align-items: center;
  padding: 10px 20px 0;
  pointer-events: ${({ disable }) => disable ? 'none' : 'initial'};

  .legoPhotoUploaderContainer {
    margin-right: 10px;

    .legoAvatarPhoto {
      :after {
        color: #ffffff;
        background-color: #cea8ef;
      }
    }
  }
`;

export const MemberName = styled.section.attrs(() => ({
  className: 'SettingsMemberProfileMemberName',
}))`
  color: #4A4A4A;
  display: flex;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const MemberRole = styled.section.attrs(() => ({
  className: 'SettingsMemberProfileMemberRole',
}))`
  display: flex;
  font-size: 16px;
  color: #657480;
`;
